module.exports = __webpack_public_path__ + "static/partner4-98007a468f923778e987635fab3e2f29.jpg";